import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { PartnerStatisticsFilterForm } from "Partner/Modules/Statistics/Components/Forms/PartnerStatisticsFilterForm";
import { Close, FilterList } from "@mui/icons-material";
import { Box, Button, Drawer, Stack, Typography } from "@mui/material";
import { useState } from "react";

const filterResource = Resources.base.partner.statistics.filter;

export const PartnerStatisticsFilterWidget = () => {
	const { t } = useResource();
	const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

	const handleFilterDrawerOpen = () => {
		setIsFilterDrawerOpen(true);
	};

	return (
		<>
			<Button
				title={t(filterResource.filters)}
				onClick={handleFilterDrawerOpen}
			>
				<FilterList />
			</Button>
			<Drawer
				anchor="right"
				open={isFilterDrawerOpen}
				onClose={() => setIsFilterDrawerOpen(false)}
				PaperProps={{
					sx: {
						p: 4,
						width: {
							xs: "100%",
							sm: "85%",
							md: "40%",
							lg: "35%",
							xl: "25%",
						},
					},
				}}
			>
				<Stack flexDirection="row" justifyContent="space-between" mb={2}>
					<Typography variant="h4">{t(filterResource.filters)}</Typography>
					<Box
						onClick={() => setIsFilterDrawerOpen(false)}
						sx={{ cursor: "pointer" }}
					>
						<Close />
					</Box>
				</Stack>
				<PartnerStatisticsFilterForm
					setIsFilterDrawerOpen={setIsFilterDrawerOpen}
				/>
			</Drawer>
		</>
	);
};
